module.exports = __webpack_public_path__ + "static/media/humza icon-04-01.83c33964.png";